import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

type TooltipBody = {
  fill: 'light' | 'dark'
  width?: string
};

export const Body = styled(Flex)<TooltipBody>`
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-family: sans-serif !important;
  text-align: center !important;
  align-items:center;
  justify-content: center;
  text-shadow: none !important;
  width: ${props => props.width || '150px'};
  padding: .5em 1em;
  border-radius: 4px;

  ${(props) => {
    switch (props.fill) {
      case 'light':
        return `
            color: #000;
            background: rgba(255, 255, 255, 0.9);
          `;
      case 'dark':
        return `
            color: #fff;
            background: rgba(17, 17, 17, 0.9);
          `;
      default:
        return '';
    }
  }}
`;
